<script setup>
import { computed, onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';

import { ppapiClient } from '@lib/pp-shop-lib/helpers';

const route = useRoute();

const activating = ref(false);
const activationSuccessful = ref(false);
const activationError = ref('');

function queryValue(value) {
    if (Array.isArray(value)) return value[0] || '';
    return typeof value === 'string' ? value : '';
}

const activationData = computed(() => ({
    email: queryValue(route.query.email).trim(),
    code: queryValue(route.query.code).trim(),
    orderId: queryValue(route.query.orderId).trim()
}));

const hasValidQuery = computed(() => Object.values(activationData.value).every(Boolean));

async function activateOrder() {
    if (!hasValidQuery.value || activating.value || activationSuccessful.value) return;

    activating.value = true;
    activationError.value = '';

    try {
        await ppapiClient.post('orders/guest/activate', activationData.value);
        activationSuccessful.value = true;
    } catch (error) {
        activationError.value = error?.message || 'Der Auftrag konnte nicht freigeschaltet werden.';
    } finally {
        activating.value = false;
    }
}

onMounted(activateOrder);
</script>

<template>
    <div class="uk-card uk-card-default uk-card-body uk-align-center uk-margin-top activate-order-card">
        <h3 class="uk-card-title">Auftrag freischalten</h3>

        <p v-if="activating" class="uk-text-muted">
            Der Auftrag wird freigeschaltet...
        </p>

        <div v-else-if="activationSuccessful" class="uk-alert-success" uk-alert>
            Der Auftrag wurde erfolgreich freigeschaltet.
        </div>

        <div v-else-if="!hasValidQuery" class="uk-alert-danger" uk-alert>
            Der Freischaltungslink ist ungültig oder unvollständig.
        </div>

        <div v-else-if="activationError" class="uk-alert-danger" uk-alert>
            <p>{{ activationError }}</p>
            <button type="button" class="uk-button uk-button-primary uk-button-small" @click="activateOrder">
                Erneut versuchen
            </button>
        </div>
    </div>
</template>

<style scoped>
.uk-card.activate-order-card {
    max-width: 680px;
    padding: 30px !important;
}
</style>